import React from "react";
import MessageList from "./MessageList";
import ChatInput from "./ChatInput";
import LoadingIndicator from "./LoadingIndicator";

/**
 * ChatContainer - Main chat container with messages and input
 * @param {Array} messages - Array of message objects
 * @param {boolean} isLoading - Whether a message is being processed
 * @param {string} error - Error message if any
 * @param {Function} onSendMessage - Callback to send a message
 * @param {Function} onClear - Callback to clear messages
 * @returns {JSX.Element}
 */
const ChatContainer = ({ messages, isLoading, error, onSendMessage, onClear }) => {
    return (
        <div className="flex flex-col h-full overflow-hidden">
            {/* Messages area */}
            <div className="flex-1 overflow-y-auto px-4">
                <MessageList messages={messages} />
                {isLoading && <LoadingIndicator />}
            </div>

            {/* Input area */}
            <ChatInput
                onSend={onSendMessage}
                disabled={isLoading}
                onClear={onClear}
                hasMessages={messages.length > 0}
            />
        </div>
    );
};

export default ChatContainer;
